// src/pages/PaddingPage.jsx
import React from 'react';
import HeroSection from '../components/HeroSection';
import BenefitsSection from '../components/BenefitsSection';
import FeaturesSectionCompact from '../components/FeaturesSectionCompact';
import ComparisonSection from '../components/ComparisonSection';
import EarningsComparisonSection from '../components/EarningsComparisonSection';
import StructureCards from '../components/StructureCards';
import HowItWorksSection from '../components/HowItWorksSection';
import FAQSection from '../components/FAQSection';
import FinalCTASection from '../components/FinalCTASection';
import Header from '../components/Header';

const PaddingPage = () => {
  // Função para ação do botão (opcional)
  const handleLiberarAcesso = () => {
    window.location.href = '/cadastro-rapido';
  };

  return (
    <main className="bg-white">
      {/* Header fixo */}
      <Header />

      {/* Hero Section */}
      <HeroSection aoClicarBotao={handleLiberarAcesso} />

      {/* Benefícios */}
      <BenefitsSection />

      {/* Recursos / Features */}
      <FeaturesSectionCompact />

      {/* Comparativo com mercado tradicional */}
      <ComparisonSection />

      {/* Comparativo de ganhos */}
      <EarningsComparisonSection />

      {/* Estrutura dos planos */}
      <StructureCards />

      {/* Como funciona */}
      <HowItWorksSection />

      {/* FAQ */}
      <FAQSection />

      {/* CTA final */}
      <FinalCTASection aoClicarBotao={handleLiberarAcesso} />
    </main>
  );
};

export default PaddingPage;
